var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-control-container"},[_c('ds-page-header',{attrs:{"title":_vm.$t('videoControl.page.title'),"subtitle":_vm.$t('videoControl.page.subtitle')}}),_c('div',{staticClass:"ds-panel ds-panel--padded"},[_c('camera-control-video',{ref:"cameraControl"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }